import { useEffect } from "react";

const SelectedInfo = (props) => {

    useEffect(() => {}, [props.storageData]);

    return (
        <>
            <div className="slv-selected-container">
                
                {/* Header */}
                <div className="slv-header">
                    <span>Available Items</span>
                    <span className="slv-count">{props.storageData.length}</span>
                </div>

                {/* List */}
                <div className="slv-list">
                    {props?.storageData?.map((item, index) => (
                        <div key={index} className="slv-item">
                            
                            <i className="fas fa-file-alt slv-icon" />

                            <span className="slv-text">
                                {item.filePath}
                            </span>

                            {/* Remove Single */}
                            <button
                                className="slv-remove-btn"
                                onClick={() => props._removeSingleItem(item, index)}
                            >
                                <i className="fas fa-times" />
                            </button>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="slv-footer">
                    <button
                        className="slv-btn secondary"
                        onClick={() => props._cancelDrawer()}
                    >
                        Cancel
                    </button>

                    <button
                        className="slv-btn danger"
                        onClick={() => props._clearAllSeleted()}
                    >
                        Remove All
                    </button>
                </div>
            </div>

            <style>{`
                .slv-selected-container {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    background: #ffffff;
                    border-radius: 12px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
                    overflow: hidden;
                }

                .slv-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 12px 16px;
                    font-weight: 600;
                    background: #f8fafc;
                    border-bottom: 1px solid #e5e7eb;
                }

                .slv-count {
                    background: #4f46e5;
                    color: #fff;
                    padding: 2px 8px;
                    border-radius: 10px;
                    font-size: 12px;
                }

                .slv-list {
                    flex: 1;
                    overflow-y: auto;
                    padding: 10px;
                }

                .slv-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px 12px;
                    border-radius: 8px;
                    transition: 0.2s;
                    position: relative;
                }

                .slv-item:hover {
                    background: #f1f5f9;
                }

                .slv-icon {
                    color: #64748b;
                    font-size: 14px;
                }

                .slv-text {
                    flex: 1;
                    font-size: 13px;
                    color: #1e293b;
                    word-break: break-all;
                }

                .slv-remove-btn {
                    background: transparent;
                    border: none;
                    color: #94a3b8;
                    cursor: pointer;
                    padding: 4px;
                    border-radius: 6px;
                    transition: 0.2s;
                }

                .slv-remove-btn:hover {
                    background: #fee2e2;
                    color: #dc2626;
                }

                .slv-footer {
                    display: flex;
                    justify-content: flex-end;
                    gap: 10px;
                    padding: 12px;
                    border-top: 1px solid #e5e7eb;
                    background: #fafafa;
                }

                .slv-btn {
                    padding: 6px 14px;
                    border-radius: 8px;
                    border: none;
                    font-size: 13px;
                    cursor: pointer;
                    transition: 0.2s;
                }

                .slv-btn.secondary {
                    background: #e5e7eb;
                    color: #374151;
                }

                .slv-btn.secondary:hover {
                    background: #d1d5db;
                }

                .slv-btn.danger {
                    background: #fee2e2;
                    color: #dc2626;
                }

                .slv-btn.danger:hover {
                    background: #fecaca;
                }
            `}</style>
        </>
    );
};

export default SelectedInfo;